import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { guaranteeItems } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-153" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-dashed border-teal bg-teal-soft px-5 py-10 text-center sm:px-10" data-id="element-154" data-mp="24l3tnaur47le">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-navy text-teal-light" data-id="element-155" data-mp="2edja23qego46">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-156" data-mp="2jbbcvssl1un5" />
        </span>
        <p className="mt-5 text-sm font-extrabold uppercase tracking-[0.16em] text-teal" data-id="element-157" data-mp="2oanzqdjgf1pq">7-day guarantee</p>
        <h2 className="mt-2 font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-158" data-mp="2sd2i6wj7nzgh">
          Try the Rhinoplasty Master Planner™ risk-free
        </h2>
        <p className="mt-4 text-lg text-ink-muted" data-id="element-159" data-mp="xyrtqp6j37b8">I can explore the complete system for 7 days. I can:</p>

        <ul className="mx-auto mt-6 grid max-w-md gap-2.5 text-left" data-id="element-160" data-mp="3sl6jttde35t8">
          {guaranteeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 text-[16px] font-medium text-ink" data-id="element-161" data-mp="3nugdodx52yxh">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-162" data-mp="3iwesnng5kpjd">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-163" data-mp="3dydb56ydkya0" />
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink-muted" data-id="element-164" data-mp="agv59525y1c8">
          If I decide during the first 7 days that the planner isn’t right for me, I can request a refund according to the stated guarantee terms.
        </p>
        <p className="mt-3 font-bold text-navy" data-id="element-165" data-mp="jqkn9nyudxj">No long-term commitment. No subscription. One simple purchase.</p>

        <CtaButton label="Try it for 7 days" className="mt-8" data-id="element-166" data-mp="2l7v1to7260o5" />
      </div>
    </section>;
}